<template>
    <div class="order">
        <div class="auto">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item, index) in carousel" :key="index">
                    <img :src="item.src" />
                </swiper-slide>
                <!-- 前一頁 -->
                <div class="swiper-button-prev" slot="button-prev"></div>
                <!-- 下一頁 -->
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'order',
    data() {
        return {
            swiperOption: {
                // 自動播放
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
                grabCursor: true,
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination'
                }
            }
        };
    },
    computed: {
        carousel() {
            return this.$store.state.carousel2;
        }
    }
};
</script>
<style lang="scss" scoped>
.order {
    font-family: '微軟正黑體', sans-serif;
    background-color: #f1f1f1;
    padding: 0 0 40px 0;
    .auto {
        width: 1440px;
        margin: auto;
        @media screen and (max-width: 1440px) {
            width: 1224px;
        }
        @media screen and (max-width: 1224px) {
            width: 96%;
        }
        .swiper-wrapper {
            img {
                width: 100%;
                object-fit: cover;
                vertical-align: middle;
            }
        }
    }
}
</style>
